import * as React from "react";
const SvgChatBubbleBottomCenterText = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M10 3h4a8 8 0 1 1 0 16v3.5c-5-2-12-5-12-11.5a8 8 0 0 1 8-8" })));
export default SvgChatBubbleBottomCenterText;
//# sourceMappingURL=ChatBubbleBottomCenterText.js.map